import classNames from 'classnames';
import type { ComponentPropsWithRef } from 'react';
import * as styles from './index.css';

interface PillProps extends ComponentPropsWithRef<'span'> {
    variant?: keyof typeof styles.variants;
    weight?: keyof typeof styles.weights;
    size?: keyof typeof styles.sizes;
}

export function Pill({
    className,
    children,
    variant = 'primary',
    weight = 'normal',
    size = 'normal',
    ...props
}: PillProps) {
    return (
        <span
            className={classNames(
                styles.base,
                styles.variants[variant],
                styles.weights[weight],
                styles.sizes[size],
                className
            )}
            {...props}
        >
            {children}
        </span>
    );
}
